import { createStore } from 'vuex';
import themeLayout from './modules/themeLayout/actionCreator';
import headerSearchData from './modules/headerSearch/actionCreator';
import auth from './modules/authentication/axios/actionCreator';
import assessmentAuth from './modules/assessmentAuth/axios/actionCreator';
import crud from './modules/crud/actionCreator';

export default createStore({
  modules: {
    themeLayout,
    headerSearchData,
    auth,
    assessmentAuth,
    crud,
  },
});
